import cx from 'classnames'

const ConditionalRender = ({ children, condition, className }) => {
  if (condition) {
    return (
      <div className={cx(className)}>
        {children}
      </div>
    )
  }

  return null
}

export default ConditionalRender



// WEBPACK FOOTER //
// ./src/scripts/components/shared/ConditionalRender/index.js